
<div class="placeholder-wrapper" :class="{ 'is-loading': loading }">
  <div v-if="loading" class="animated-placeholder"></div>
  <div class="content" :class="{ hidden: loading }">
    <slot></slot>
  </div>
</div>
